import { injectable } from 'inversify';
import { store } from '../../state/store';
import { setTheme, useThemeSelector } from './theme.slice';

@injectable()
export class ThemeService {
  useThemeSelector = useThemeSelector;

  dispatchSetTheme(theme: string): void {
    store.dispatch(setTheme(theme));
  }
}
